import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { ContractList } from 'types/api'

// Hand-written until the OpenAPI types are regenerated.
export type RenewalAnswer = 'EXTEND' | 'NOT_EXTEND'

export type ContractRenewal = {
  can_answer: boolean
  answer: RenewalAnswer | null
  note: string
  answered_at: string | null
}

export type ContractWithRenewal = ContractList & { renewal?: ContractRenewal }

export function useAnswerRenewal() {
  const queryClient = useQueryClient()
  const toast = useToast()
  const { t } = useTranslation('toast')
  const onError = useOnError()

  async function answerRenewal({
    id,
    answer,
    note
  }: {
    id: string
    answer: RenewalAnswer
    note: string
  }) {
    const res = await apiClient.post(
      `${SNA_PREFIX}contracts/${id}/renewal-answer`,
      { answer, note },
      { params: { type: 'offer' } }
    )
    return res.data
  }

  return useMutation({
    mutationFn: answerRenewal,
    onSuccess: () => {
      toast.success({ message: t('renewalAnswered') })
      queryClient.invalidateQueries({ queryKey: ['contracts'] })
    },
    onError
  })
}
